// export const UPLOAD_SERVER_ENDPOINT='http://minio-upload-server.qiddiya.link';
// export const DOWNLOAD_SERVER_ENDPOINT='http://minio.qiddiya.link/uploads';
//export const API_ENDPOINT = 'http://cms.qiddiya.link/api/qiddiya-flat';
//export const API_ENDPOINT = 'http://qiddiya-api-schema.surge.sh'
import {  CustomRoutes,Authenticated} from "react-admin";
import { loadFromairtable } from "./core/api/airtable";
import { Route } from "react-router-dom";
import { find } from "lodash";

const apiKey = import.meta.env.REACT_APP_AIRTABLE_API_KEY;
//"baseName": "appjEjThc7tJY967w"
const baseName = import.meta.env.REACT_APP_AIRTABLE_BASE_NAME;

export const roles = ['admin', 'contractor', 'safetysupervisor', 'areamanager', 'saftymanager', 'trainer','saftysupervisor','saftysupervisortrainer','areamangertrainer','seniorareamanager','inspector','readonly','biuser'];

export function generateRoleFields(baseFieldNames, roles) {
  
  const roleFields = roles.flatMap(role => 
    baseFieldNames.map(baseFieldName => `${role}_${baseFieldName}`)
  );
  return roleFields;
}
export function generateRole(baseFieldNames, roles) {
  const roleFields = roles.flatMap(role => `role_${role}`
  );
  return roleFields;
}

export function generateSQLRoleFields(baseFieldNames, roles) {
  const roleFields = roles.flatMap(role => 
    baseFieldNames.map(baseFieldName => `${role}_${baseFieldName}`)
  );
  return roleFields.join(', ');
}

const baseFieldNames = ['list', 'show', 'add', 'edit', 'delete']; // Adjust based on your requirements




export const googleMapsApiKey = import.meta.env.REACT_APP_GOOGLE_MAPS_API_KEY;

export const tablesToLoad = [
    { tableName: "admin", alasqlTableName: "admin", fields: ["name", "value", "notes"] },
    { tableName: "translations", alasqlTableName: "translations", fields: ["level1", "level2", "level3", "level4", "ar", "en", "level5"] },
    { tableName: "custom_routes",alasqlTableName: "custom_routes", fields: ["name", "link", "url"] },
    { tableName: "resources",alasqlTableName: "resources", fields: [
      "watched_column","grid_class", "grid_xs", "grid_sm", "is_require_separator", "is_require_label", "label_text",
      "edit_input_widget_type", "is_expand_field", "is_inline", "resource_name", "read_group", "source_name",
      "source_name_alias", "annotation", "is_filter",'is_filter_show', "field_meta", "field_type", "field_widget_type",
      "input_widget_type", "filter_widget_type", "is_enabled", "is_list_field", "is_show_field", "is_edit_field",
      "is_create_field",  "write_group", "full_width", "is_required", "css_class",
      "workflow_conditional","workflow_column","workflow_conditional_show","workflow_conditional_hide",
      ...generateRole(baseFieldNames, roles),

    ] },
    { tableName: "resource_permistions", alasqlTableName: "resource_permistions", fields: [
      "init_values","is_custom_tab", "is_grid_inputs", "grid_class", "columnSpacing", "extra", "is_expand", "expand_resource",
      "expand_source", "expand_destination", "menu_section", "list_is_tab", "list_is_calendar","list_tabs", "list_tab_filter",
      "list_tab_filter_value", "form_mode", "inline_update", "inline_create", "resource_name","icon",
      ...generateRoleFields(baseFieldNames, roles),


    ] },
    { tableName: "custom_tabs", alasqlTableName: "custom_tabs", fields: ["resource_name", "tab_id", "width_class", "new_line_after"] },
    { tableName: "workflow", alasqlTableName: "workflows", fields: [
      "WorkFlowName", "Module", "StateColumn", "StateValue", "resources", 
     "title", "icon", "alert_accept", "alert_error", "Actions", "class", "validation_text", "color",
      "enable_validate", "validation_title", "backgroundColor","type",
      ...generateRole(baseFieldNames, roles),

    ] },
  ];

  //console.log(tablesToLoad);


   const iframeRoutes = [
  
    {
      path: "/Reports",
      src: "https://reports-api.tatweertransit.com/Aman",
    }
  ];



  export const generateIframeRoutes = () => {
    return (
      <CustomRoutes>
        {iframeRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={
              <Authenticated requireAuth>
              <iframe
                width="100%"
                height="100%"
                frameBorder="0"
                src={`${route.src}?token=${window.localStorage.getItem(
                  "tokenLogin"
                )}`}
              />
              </Authenticated>
            }
          />
        ))}
      </CustomRoutes>
    );
  };


  export  const loadAllTablesFromAirtable = async () => {
    const loadedTables = {};
  
    for (const table of tablesToLoad) {
      const { tableName, fields } = table;
      const data = await loadFromairtable({ apiKey, baseName, tableName, fields });
      loadedTables[tableName] = data;
    }
  
    return loadedTables;
  };

  export const loadTranslationsFromAirtable = async () => {
    const translationsConfig = tablesToLoad.find(t => t.tableName === 'translations');
    if (!translationsConfig) return;
    const { tableName, alasqlTableName, fields } = translationsConfig;
    const data = await loadFromairtable({ apiKey, baseName, tableName, fields });
    if (!Array.isArray(data) || data.length === 0) return;
    alasql(`DROP TABLE IF EXISTS ${alasqlTableName}`);
    alasql(`CREATE TABLE ${alasqlTableName}`);
    alasql(`INSERT INTO ${alasqlTableName} SELECT * FROM ?`, [data]);
  };


  export function setProperty(target, data, property) {
    const { name, localStorageKey, defaultValue, propertyName } = property;
    const { value = defaultValue } = find(data, { name }) || {};
  
    if (propertyName) {
      target[propertyName] = value;
    }
  
    localStorage.setItem(localStorageKey, value || defaultValue || "");
  }